import lazyPage from './routes-options/lazyPage';
import React from "react";
import {AdminFeedbackProvider} from './context/adminFeedback';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/authContext";
import PrivateRoute from "./routes-options/PrivateRoute";
import AdminLanding from './routes-options/AdminLanding';

import SectionPage, { EmptySectionCard } from './components/layouts/SectionPage';

const ErrorReportsPage = lazyPage(() => import('./pages/private/ErrorReportsPage'));
const ConsultationRequestsPage = lazyPage(() => import('./pages/private/ConsultationRequestsPage'));
const SiteSettingsPage = lazyPage(() => import('./pages/private/SiteSettingsPage'));
const PublicationPlanPage = lazyPage(() => import('./pages/private/PublicationPlanPage'));
const AnalyticsPage = lazyPage(() => import('./pages/private/AnalyticsPage'));
const SitePublicationPage = lazyPage(() => import('./pages/private/SitePublicationPage'));
const AdvertisementsPage = lazyPage(() => import('./pages/private/AdvertisementsPage'));
const SiteSocialLinksPage = lazyPage(() => import('./pages/private/SiteSocialLinksPage'));
const PageSeoPage = lazyPage(() => import('./pages/private/PageSeoPage'));
const ArticleReviewsPage = lazyPage(() => import('./pages/private/ArticleReviewsPage'));
const ReviewRequestsPage = lazyPage(() => import('./pages/private/ReviewRequestsPage'));
const ContactRequestsPage = lazyPage(() => import('./pages/private/ContactRequestsPage'));
const AdvertisingRequestsPage = lazyPage(() => import('./pages/private/AdvertisingRequestsPage'));
const SitePagesPage = lazyPage(() => import('./pages/private/SitePagesPage'));
const SubscribersPage = lazyPage(() => import('./pages/private/SubscribersPage'));
const NewslettersPage = lazyPage(() => import('./pages/private/NewslettersPage'));
const LoginPage = lazyPage(() => import('./pages/public/LoginPage'));
const ClientsListPage = lazyPage(() => import('./pages/private/ClientsListPage'));
const ClientCreatePage = lazyPage(() => import('./pages/private/ClientCreatePage'));
const ClientCardPage = lazyPage(() => import('./pages/private/ClientCardPage'));
const ResearchListPage = lazyPage(() => import('./pages/private/ResearchListPage'));
const ResearchCreatePage = lazyPage(() => import('./pages/private/ResearchCreatePage'));
const ResearchCardPage = lazyPage(() => import('./pages/private/ResearchCardPage'));
const ArticlesListPage = lazyPage(() => import('./pages/private/ArticlesListPage'));
const ArticleEditorPage = lazyPage(() => import('./pages/private/ArticleEditorPage'));
const MediaLibraryPage = lazyPage(() => import('./pages/private/MediaLibraryPage'));
const MediaUploadPage = lazyPage(() => import('./pages/private/MediaUploadPage'));
const MediaCardPage = lazyPage(() => import('./pages/private/MediaCardPage'));
const CategoriesListPage = lazyPage(() => import('./pages/private/CategoriesListPage'));
const CategoryEditorPage = lazyPage(() => import('./pages/private/CategoryEditorPage'));
const AuthorsListPage = lazyPage(() => import('./pages/private/AuthorsListPage'));
const AuthorCardPage = lazyPage(() => import('./pages/private/AuthorCardPage'));
const CandidatesListPage = lazyPage(() => import('./pages/private/CandidatesListPage'));
const CandidateSettingsPage = lazyPage(() => import('./pages/private/CandidateSettingsPage'));
const CandidateCardPage = lazyPage(() => import('./pages/private/CandidateCardPage'));
const AutomationListPage = lazyPage(() => import('./pages/private/AutomationListPage'));
const AutomationSettingsPage = lazyPage(() => import('./pages/private/AutomationSettingsPage'));
const PromptPresetsPage = lazyPage(() => import('./pages/private/PromptPresetsPage'));
const AutomationCreatePage = lazyPage(() => import('./pages/private/AutomationCreatePage'));
const AutomationCardPage = lazyPage(() => import('./pages/private/AutomationCardPage'));

const AppRoutes = () => {
    return (
        <AuthProvider>
            <Router><AdminFeedbackProvider>
                <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/site-settings" element={<PrivateRoute><SiteSettingsPage /></PrivateRoute>} />
                    <Route path="/analytics" element={<PrivateRoute><AnalyticsPage /></PrivateRoute>} />
                    <Route path="/site-publication" element={<PrivateRoute><SitePublicationPage /></PrivateRoute>} />
                    <Route path="/advertisements" element={<PrivateRoute><AdvertisementsPage /></PrivateRoute>} />
                    <Route path="/site-social-links" element={<PrivateRoute><SiteSocialLinksPage /></PrivateRoute>} />
                    <Route path="/page-seo" element={<PrivateRoute><PageSeoPage /></PrivateRoute>} />
                    <Route path="/article-reviews" element={<PrivateRoute><ArticleReviewsPage /></PrivateRoute>} />
                    <Route path="/article-reviews/:id" element={<PrivateRoute><ArticleReviewsPage /></PrivateRoute>} />
                    <Route path="/review-requests" element={<PrivateRoute><ReviewRequestsPage /></PrivateRoute>} />
                    <Route path="/review-requests/:id" element={<PrivateRoute><ReviewRequestsPage /></PrivateRoute>} />
                    <Route path="/consultation-requests" element={<PrivateRoute><ConsultationRequestsPage /></PrivateRoute>} />
                    <Route path="/consultation-requests/:id" element={<PrivateRoute><ConsultationRequestsPage /></PrivateRoute>} />
                    <Route path="/error-reports" element={<PrivateRoute><ErrorReportsPage /></PrivateRoute>} />
                    <Route path="/error-reports/:id" element={<PrivateRoute><ErrorReportsPage /></PrivateRoute>} />
                    <Route path="/contact-requests" element={<PrivateRoute><ContactRequestsPage /></PrivateRoute>} />
                    <Route path="/contact-requests/:id" element={<PrivateRoute><ContactRequestsPage /></PrivateRoute>} />
                    <Route path="/advertising-requests" element={<PrivateRoute><AdvertisingRequestsPage /></PrivateRoute>} />
                    <Route path="/advertising-requests/:id" element={<PrivateRoute><AdvertisingRequestsPage /></PrivateRoute>} />
                    <Route path="/site-pages" element={<PrivateRoute><SitePagesPage /></PrivateRoute>} />
                    <Route path="/subscribers" element={<PrivateRoute><SubscribersPage /></PrivateRoute>} />
                    <Route path="/newsletters" element={<PrivateRoute><NewslettersPage /></PrivateRoute>} />
                    <Route path="/newsletters/:id" element={<PrivateRoute><NewslettersPage /></PrivateRoute>} />
                    <Route path="/subscribers/:id" element={<PrivateRoute><SubscribersPage /></PrivateRoute>} />
                    <Route element={<PrivateRoute><SectionPage section="clients" /></PrivateRoute>}>
                        <Route path="/clients" element={<ClientsListPage />} />
                        <Route path="/clients/create" element={<ClientCreatePage />} />
                        <Route path="/clients/card" element={<EmptySectionCard base="/clients" label="клиента" />} />
                        <Route path="/clients/:id" element={<ClientCardPage />} />
                    </Route>
                    <Route element={<PrivateRoute><SectionPage section="categories" /></PrivateRoute>}>
                        <Route path="/categories" element={<CategoriesListPage />} />
                        <Route path="/categories/create" element={<CategoryEditorPage key="create" isNew />} />
                        <Route path="/categories/card" element={<EmptySectionCard base="/categories" label="рубрику" />} />
                        <Route path="/categories/:id" element={<CategoryEditorPage />} />
                    </Route>
                    <Route element={<PrivateRoute><SectionPage section="authors" /></PrivateRoute>}>
                        <Route path="/authors" element={<AuthorsListPage />} />
                        <Route path="/authors/create" element={<AuthorCardPage key="create" isNew />} />
                        <Route path="/authors/card" element={<EmptySectionCard base="/authors" label="автора" />} />
                        <Route path="/authors/:id" element={<AuthorCardPage />} />
                    </Route>
                    <Route element={<PrivateRoute><SectionPage section="candidates" /></PrivateRoute>}>
                        <Route path="/candidates" element={<CandidatesListPage />} />
                        <Route path="/candidates/settings" element={<CandidateSettingsPage />} />
                        <Route path="/candidates/card" element={<EmptySectionCard base="/candidates" label="кандидата" />} />
                        <Route path="/candidates/:id" element={<CandidateCardPage />} />
                    </Route>
                    <Route element={<PrivateRoute><SectionPage section="research" /></PrivateRoute>}>
                        <Route path="/research" element={<ResearchListPage />} />
                        <Route path="/research/create" element={<ResearchCreatePage />} />
                        <Route path="/research/card" element={<EmptySectionCard base="/research" label="исследование" />} />
                        <Route path="/research/:id" element={<ResearchCardPage />} />
                    </Route>
                    <Route element={<PrivateRoute><SectionPage section="articles" /></PrivateRoute>}>
                        <Route path="/articles" element={<ArticlesListPage />} />
                        <Route path="/articles/create" element={<ArticleEditorPage key="create" isNew />} />
                        <Route path="/articles/publication-plan" element={<PublicationPlanPage />} />
                        <Route path="/articles/card" element={<EmptySectionCard base="/articles" label="статью" />} />
                        <Route path="/articles/:id" element={<ArticleEditorPage />} />
                        <Route path="/automation" element={<AutomationListPage />} />
                        <Route path="/automation/settings" element={<AutomationSettingsPage />} />
                        <Route path="/automation/prompts" element={<PromptPresetsPage />} />
                        <Route path="/automation/create" element={<AutomationCreatePage />} />
                        <Route path="/automation/card" element={<EmptySectionCard base="/automation" label="задание автоматизации" />} />
                        <Route path="/automation/:id" element={<AutomationCardPage />} />
                    </Route>
                    <Route element={<PrivateRoute><SectionPage section="media" /></PrivateRoute>}>
                        <Route path="/media" element={<MediaLibraryPage />} />
                        <Route path="/media/create" element={<MediaUploadPage />} />
                        <Route path="/media/card" element={<EmptySectionCard base="/media" label="изображение" />} />
                        <Route path="/media/:id" element={<MediaCardPage />} />
                    </Route>
                    <Route
                        path="/dashboard"
                        element={
                            <PrivateRoute>
                                <AdminLanding />
                            </PrivateRoute>
                        }
                    />
                    <Route path="*" element={<PrivateRoute><AdminLanding /></PrivateRoute>} />
                </Routes>
            </AdminFeedbackProvider></Router>
        </AuthProvider>
    );
};

export default AppRoutes;
